import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../../utils/constants";

const GreenModal = ({ show, handleClose, children }: { show: boolean; handleClose: () => void; children: React.ReactNode }) => {
  return (
    <Modal open={show} onClose={() => handleClose()} className="flex justify-center items-center">
      <div className="w-full md:w-5/12 h-auto max-h-3/4 p-10 bg-docnote-green rounded-2xl flex flex-col justify-between relative">
        <CloseIcon htmlColor={colors.DarkBlue} className="absolute top-3 right-3 cursor-pointer" onClick={() => handleClose()} />
        {children}
      </div>
    </Modal>
  );
};

export default GreenModal;
